module.exports = __webpack_public_path__ + "img/janice.e979614d.svg";